import {useEffect, useState} from 'react';
import {failure, initial, pending} from '../domain/RemoteData.model';

/**
 *
 * @param initialData
 * @param {function(): Promise<RemoteData>} dataFetchingCallback
 * @returns {RemoteData}
 */
export const useRemoteData = ({ initialData, dataFetchingCallback }) => {
  const [remoteData, setRemoteData] = useState(initial(initialData));

  useEffect(() => {
    const loadRemoteData = async () => {
      setRemoteData(pending());
      try {
        setRemoteData(await dataFetchingCallback());
      } catch (e) {
        // Sin esto, un callback que reviente deja el estado en pending para
        // siempre (spinner infinito): el .then() de abajo se tragaba el rechazo.
        setRemoteData(failure(e?.message || 'Unknown error'));
      }
    }
    loadRemoteData().then();
  }, [dataFetchingCallback]);

  return remoteData;
}